<template>
  <div v-if="api_data.Farmer" id="operationLivelihoodInformation">
    <div class="card rounded-0 card-custom gutter-b">
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="card-label">
            <div class="font-weight-bolder">
              {{ $t('Livelihood') }}
            </div>
            <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ $t('Information') }}</span>
          </div>
        </div>
      </div>
      <div class="card-body">
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood'"
            v-bind:head_title="'Details'"
            v-bind:default_autocomplete_list="livelihood_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood_education'"
            v-bind:head_title="'Education'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <div class="row">
          <div class="col-md-6">
            <text-input
                v-bind:form_label="'NREGA Number'"
                v-bind:form_class="'form-control-solid input-lg'"
                v-bind:file_input_name="'livelihood_nrega_number'"
                :api_data="api_data"
            ></text-input>
          </div>
          <div class="col-md-6">
            <text-input
                v-bind:form_label="'Job-Card Number'"
                v-bind:form_class="'form-control-solid input-lg'"
                v-bind:file_input_name="'livelihood_job_card_number'"
                :api_data="api_data"
            ></text-input>
          </div>
        </div>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood_migration_location'"
            v-bind:head_title="'Migration Location'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood_migration_duration'"
            v-bind:head_title="'Migration Duration'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood_income'"
            v-bind:head_title="'Income'"
            v-bind:default_autocomplete_list="livelihood_income_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood_migration_with_family'"
            v-bind:head_title="'Migration with Family'"
            v-bind:default_autocomplete_list="livelihood_migration_with_family_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood_migration_with_family_location'"
            v-bind:head_title="'Migration with Family Location'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'operation-livelihood-information',
  props: {
    api_data: Object,
  },
  data: () => ({
    land_forest_cultivation_default_autocomplete: [],
    livelihood_default_autocomplete: [
      'બેરોજગાર',
      'સ્વરોજગાર',
      'અભ્યાસ',
      'ખેતી',
      'મજૂરી - ખેતમજૂરી',
      'મજૂરી - બાંધકામ',
      'મજૂરી - ખાણ',
      'મજૂરી - વન',
      'મજૂરી - સિરામિક',
      'મજૂરી - અન્ય'
    ],
    livelihood_income_default_autocomplete: [
      'માસિક',
      'વાર્ષિક',
      'દિવસ દીઠ',
      'Monthly',
      'Yearly',
      'Per Day',
    ],
    livelihood_migration_with_family_default_autocomplete: [
      'પત્ની',
      'પતિ',
      'બાળકો',
      'Wife',
      'Husband',
      'Children',
    ],
    land_forest_house_default_autocomplete: [
      'કાચું', 'પાકું', 'Raw', 'Complete'
    ],
    land_forest_well_default_autocomplete: [
      'કાચું', 'પાકું', 'Raw', 'Complete'
    ],
    default_question_options: [
      {
        'label': 'Yes',
        'value': 'yes',
      },
      {
        'label': 'No',
        'value': 'no',
      },
    ],
  })
}
</script>
